module.exports = "/images/el.svg";